import { createApiSaga } from '../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../middleware/api';
import {
  GET_EDIT_EARTHQUAKE_REQUEST,
  GET_EDIT_EARTHQUAKE_SUCCESS,
  GET_EDIT_EARTHQUAKE_FAILURE,
  UPDATE_EDIT_EARTHQUAKE_REQUEST,
  UPDATE_EDIT_EARTHQUAKE_SUCCESS,
  UPDATE_EDIT_EARTHQUAKE_FAILURE,
  CREATE_EDIT_EARTHQUAKE_REQUEST,
  CREATE_EDIT_EARTHQUAKE_SUCCESS,
  CREATE_EDIT_EARTHQUAKE_FAILURE,
  EDIT_EARTHQUAKE_VOLCANO_REQUEST,
  EDIT_EARTHQUAKE_VOLCANO_SUCCESS,
  EDIT_EARTHQUAKE_VOLCANO_FAILURE,
  EDIT_EARTHQUAKE_VOLCANO_SEARCH_REQUEST,
  EDIT_EARTHQUAKE_VOLCANO_SEARCH_SUCCESS,
  EDIT_EARTHQUAKE_VOLCANO_SEARCH_FAILURE,
  EDIT_EARTHQUAKE_TSUNAMI_REQUEST,
  EDIT_EARTHQUAKE_TSUNAMI_SUCCESS,
  EDIT_EARTHQUAKE_TSUNAMI_FAILURE,
  EDIT_EARTHQUAKE_TSUNAMI_SEARCH_REQUEST,
  EDIT_EARTHQUAKE_TSUNAMI_SEARCH_SUCCESS,
  EDIT_EARTHQUAKE_TSUNAMI_SEARCH_FAILURE,
  EDIT_EARTHQUAKE_REFERENCE_REQUEST,
  EDIT_EARTHQUAKE_REFERENCE_SUCCESS,
  EDIT_EARTHQUAKE_REFERENCE_FAILURE,
  EDIT_EARTHQUAKE_REFERENCE_SEARCH_REQUEST,
  EDIT_EARTHQUAKE_REFERENCE_SEARCH_SUCCESS,
  EDIT_EARTHQUAKE_REFERENCE_SEARCH_FAILURE,
  EDIT_EARTHQUAKE_REGION_REQUEST,
  EDIT_EARTHQUAKE_REGION_SUCCESS,
  EDIT_EARTHQUAKE_REGION_FAILURE,
  EDIT_EARTHQUAKE_COUNTRY_REQUEST,
  EDIT_EARTHQUAKE_COUNTRY_SUCCESS,
  EDIT_EARTHQUAKE_COUNTRY_FAILURE,
  EDIT_EARTHQUAKE_AREA_SUCCESS,
  EDIT_EARTHQUAKE_AREA_REQUEST,
  EDIT_EARTHQUAKE_AREA_FAILURE,
  EDIT_EARTHQUAKE_LOCATION_REQUEST,
  EDIT_EARTHQUAKE_LOCATION_SUCCESS,
  EDIT_EARTHQUAKE_LOCATION_FAILURE,
} from './earthquakeEditReducer';


const getEarthquakeSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}`, ...action }),
  requestType: GET_EDIT_EARTHQUAKE_REQUEST,
  successType: GET_EDIT_EARTHQUAKE_SUCCESS,
  failureType: GET_EDIT_EARTHQUAKE_FAILURE,
});

const createEarthquakeSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/earthquakes', ...action }),
  requestType: CREATE_EDIT_EARTHQUAKE_REQUEST,
  successType: CREATE_EDIT_EARTHQUAKE_SUCCESS,
  failureType: CREATE_EDIT_EARTHQUAKE_FAILURE,
  successMessage: 'Saved',
});

const updateEarthquakeSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}`, ...action }),
  requestType: UPDATE_EDIT_EARTHQUAKE_REQUEST,
  successType: UPDATE_EDIT_EARTHQUAKE_SUCCESS,
  failureType: UPDATE_EDIT_EARTHQUAKE_FAILURE,
  successMessage: 'Saved',
});

const getVolcanoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}/volcanoes`, ...action }),
  requestType: EDIT_EARTHQUAKE_VOLCANO_REQUEST,
  successType: EDIT_EARTHQUAKE_VOLCANO_SUCCESS,
  failureType: EDIT_EARTHQUAKE_VOLCANO_FAILURE,
});

const searchVolcanoesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/volcanoes', ...action }),
  requestType: EDIT_EARTHQUAKE_VOLCANO_SEARCH_REQUEST,
  successType: EDIT_EARTHQUAKE_VOLCANO_SEARCH_SUCCESS,
  failureType: EDIT_EARTHQUAKE_VOLCANO_SEARCH_FAILURE,
});


const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}/tsunamis`, ...action }),
  requestType: EDIT_EARTHQUAKE_TSUNAMI_REQUEST,
  successType: EDIT_EARTHQUAKE_TSUNAMI_SUCCESS,
  failureType: EDIT_EARTHQUAKE_TSUNAMI_FAILURE,
});

const searchTsunamisSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: EDIT_EARTHQUAKE_TSUNAMI_SEARCH_REQUEST,
  successType: EDIT_EARTHQUAKE_TSUNAMI_SEARCH_SUCCESS,
  failureType: EDIT_EARTHQUAKE_TSUNAMI_SEARCH_FAILURE,
});

const getReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}/references`, ...action }),
  requestType: EDIT_EARTHQUAKE_REFERENCE_REQUEST,
  successType: EDIT_EARTHQUAKE_REFERENCE_SUCCESS,
  failureType: EDIT_EARTHQUAKE_REFERENCE_FAILURE,
});

const searchReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: EDIT_EARTHQUAKE_REFERENCE_SEARCH_REQUEST,
  successType: EDIT_EARTHQUAKE_REFERENCE_SEARCH_SUCCESS,
  failureType: EDIT_EARTHQUAKE_REFERENCE_SEARCH_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/regions', ...action }),
  requestType: EDIT_EARTHQUAKE_REGION_REQUEST,
  successType: EDIT_EARTHQUAKE_REGION_SUCCESS,
  failureType: EDIT_EARTHQUAKE_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/countries', ...action }),
  requestType: EDIT_EARTHQUAKE_COUNTRY_REQUEST,
  successType: EDIT_EARTHQUAKE_COUNTRY_SUCCESS,
  failureType: EDIT_EARTHQUAKE_COUNTRY_FAILURE,
});

const getAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/areas', ...action }),
  requestType: EDIT_EARTHQUAKE_AREA_REQUEST,
  successType: EDIT_EARTHQUAKE_AREA_SUCCESS,
  failureType: EDIT_EARTHQUAKE_AREA_FAILURE,
});

const getLocationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/locations', ...action }),
  requestType: EDIT_EARTHQUAKE_LOCATION_REQUEST,
  successType: EDIT_EARTHQUAKE_LOCATION_SUCCESS,
  failureType: EDIT_EARTHQUAKE_LOCATION_FAILURE,
});


export const earthquakeEditSagas = [
  getEarthquakeSaga,
  createEarthquakeSaga,
  updateEarthquakeSaga,
  getVolcanoSaga,
  searchVolcanoesSaga,
  getTsunamiSaga,
  searchTsunamisSaga,
  getReferencesSaga,
  searchReferencesSaga,
  getRegionsSaga,
  getCountriesSaga,
  getAreasSaga,
  getLocationsSaga,
];
